/**
 * @generated SignedSource<<4604a1c63b71d190e205fc9b219d812c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DelegatesContainerFragment$data = {
  readonly voters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"VoterCardFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "DelegatesContainerFragment";
};
export type DelegatesContainerFragment$key = {
  readonly " $data"?: DelegatesContainerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DelegatesContainerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "voters"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "seed"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "statement"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "topIssues"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "topStakeholders"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./DelegatesContainerPaginationQuery.graphql')
    }
  },
  "name": "DelegatesContainerFragment",
  "selections": [
    {
      "alias": "voters",
      "args": [
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "seed",
          "variableName": "seed"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "statement",
              "variableName": "statement"
            },
            {
              "kind": "Variable",
              "name": "topIssues",
              "variableName": "topIssues"
            },
            {
              "kind": "Variable",
              "name": "topStakeholders",
              "variableName": "topStakeholders"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "DelegatesConnection",
      "kind": "LinkedField",
      "name": "__DelegatesContainerFragment_voters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DelegatesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Delegate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VoterCardFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "b28a9c57a8b9d2499e85d6b80e6a4bc9";

export default node;
